import * as React from 'react';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { Link as RouterLink } from 'react-router-dom';

// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  TextField,
  CardContent,
  Alert,
  MenuItem,
  TableHead,
  IconButton,
  Collapse,
  Divider,
  Rating,
  List
  // Snackbar
} from '@mui/material';
import Label from 'src/components/Label';
import { LoadingButton } from '@mui/lab';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { ChangeRoleModal, ResetUserPassword, UserListHead } from '../sections/@dashboard/user';

import pallete from '../theme/palette';
import { api } from '../Api';
import { useTranslation } from 'react-i18next';
import EditUserModal from 'src/sections/@dashboard/user/EditUserModal';
import AddAdminModal from 'src/sections/@dashboard/user/AddAdminModal';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import dayjs from 'dayjs';
import UserDetailPaymentAdmin from 'src/sections/@dashboard/user/UserDetailPaymentAdmin';
import CompanyProfile from 'src/sections/@dashboard/user/CompanyProfileModal';

export default function Customers() {
  const { t } = useTranslation();

  const TABLE_HEAD = [
    { id: 'customer', label: t('Customer'), alignRight: false },
    { id: 'companyname', label: t('Company Name'), alignRight: false },
    // { id: 'email', label: t('Users.table.1'), alignRight: false },
    { id: 'joined', label: 'Joined', alignRight: false },
    { id: 'accounttype', label: 'Account Type', alignRight: false },
    { id: 'status', label: t('Users.table.4'), alignRight: false },
    { id: 'action', label: t('Users.table.5'), alignRight: false }
  ];
  const [permission, setpermission] = useState([]);
  const requirement = [
    'visible',
    'edit',
    'edit role',
    'change status',
    'change password',
    'login history'
  ];

  function checkRender() {
    let check = 'customers';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );

    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    checkRender();
  }, []);

  const [list, setlist] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [search, setsearch] = useState('');
  const [status, setstatus] = useState(null);
  const [loading, setloading] = useState(true);
  const [searchLoading, setsearchLoading] = useState(false);
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);
  const [statusss, setStatus] = useState(null);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [selectedStatus, setSelectedStatus] = useState('');
  const [alertSuccess, setalertSuccess] = useState({ visible: false, message: '' });
  const [productDetailsOpen, setProductDetailsOpen] = useState(false);
  const [buyerratingmodal, setbuyerratingmodal] = useState(false);
  const [sellerratingmodal, setsellerratingmodal] = useState(false);

  const [statusfilter, setStatusFilter] = useState(null);
  const [roles, setRoles] = useState([]);
  const [reasondrop, setReasondrop] = useState(null);
  const [userdetail, setuserdetail] = useState('');
  const [userpaymentmodal, setUserPaymentModal] = useState(false);
  const [statusLoading, setstatusLoading] = useState(false);
  const handlePageChange = (event, value) => {
    list.length = 0;
    setPage(value);
    getCustomers(value, statusfilter, reasondrop);
  };

  function getCustomers(page, filter, role) {
    setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    // Construct the query string
    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    filter && filter?.name != 'All' && queryParams.append('status', filter.id);
    // role && role?.role_name != 'All' && queryParams.append('role_id', role.id);
    // queryParams.append('admin', true);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(`${api.getCustomers}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setlist(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
        } else {
          setlist([]);
          setpagesCount(0);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  function getCustomerstatus() {
    // setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    const params = new URLSearchParams();
    params.append('type', 'user');
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(`${api.get_user_status}?${params.toString()}`, requestOptions)
      // fetch(api.get_user_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          // console.log('result data ===>', result.data);
          let totalData = [{ id: 10, name: 'All' }, ...result?.data];
          setStatusList(totalData);
          setStatusFilter(totalData.find((item) => item.id === 10));
        } else {
          setStatusList([]);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        // setloading(false);
      });
  }

  useEffect(() => {
    const getRoles = async () => {
      const myHeaders = new Headers();
      const token = localStorage.getItem('token');
      myHeaders.append('Authorization', `Bearer ${token}`);

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      try {
        const response = await fetch(api.getRoleNames, requestOptions);
        const result = await response.json();
        if (result.success) {
          let roleData = [{ id: 10, role_name: 'All' }, ...result?.data];
          setRoles(roleData);
          setReasondrop(roleData.find((item) => item?.id == 10));
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };
    getRoles();
  }, []);

  const handleOpenStatus = () => setOpenStatus(true);

  const handleCloseStatus = () => {
    setOpenStatus(false);
    setStatus(null);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getCustomers(1, statusfilter, reasondrop);
    getCustomerstatus();
  }, []);

  const [open, setOpen] = React.useState(false);
  const [openStatus, setOpenStatus] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [openReset, setOpenReset] = React.useState(false);
  const [user, setuser] = useState(null);
  // console.log('🚀 ~ user:', user);
  const [AddAdminmodal, setAddAdminModal] = useState(false);

  const [reviewratinglist, setreviewratinglist] = useState([]);
  const [loadingReviews, setloadingReviews] = useState(false);
  const [companymodal, setcompanymodal] = useState(false);
  const [companyprofiledata, setcompanyprofiledata] = useState(null);
  // useEffect(() => {
  //   if (user) {
  //     const selected = statusList?.filter(
  //       (e) => e.value.toLowerCase() === user?.status.toLowerCase()
  //     );
  //     setSelectedStatus(selected[0]);
  //   }
  // }, [user]);

  useEffect(() => {
    if (user && statusList?.length) {
      const selected = statusList.filter(
        (e) => e.value?.toLowerCase() === user?.status?.toLowerCase()
      );
      setSelectedStatus(selected[0] || null);
    }
  }, [user, statusList]);

  function openModalStatus(user) {
    setuser(user);
    handleOpenStatus();
  }

  function openResetModal(user) {
    setuser(user);
    setOpenReset(true);
  }

  const handleCloseUserModal = () => setOpenUser(false);
  const handleCloseModal = () => setOpenReset(false);
  const handleAddAdminCloseModal = () => setAddAdminModal(false);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isUserNotFound = list.length === 0;

  const style = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const boxStyle = {
    maxWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };
  const HistoryboxStyle = {
    minWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };

  const refreshAdmin = () => {
    setlist([]);
    setOpen(false);
    setOpenUser(false);
    getCustomers(page, statusfilter, reasondrop);
  };

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getCustomers(page);
    }
  }, [search]);

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const handlefilterstatus = (event) => {
    setStatusFilter(event.target.value);
    list.length = 0;
    const filter = event.target.value;
    setPage(1);
    getCustomers(1, filter, reasondrop);
  };

  function handleChangeStatus(status) {
    setstatusLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('id', user.id);
    formdata.append('status', status.id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    // setloading(true);

    fetch(api.update_user_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);
        if (status === 200 || status === 201) {
          refreshAdmin();
          getCustomers(1, statusfilter, reasondrop);
          handleCloseStatus();
          setalertSuccess({ visible: true, message: response.message });
          setTimeout(() => {
            setalertSuccess({ visible: false, message: response.message });
          }, 2000);
        } else {
          setalert({ visible: true, message: 'Something went wrong' });
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        // setloading(false);
        //   handleCloseStatus();
        setstatusLoading(false);
      });
  }

  const historystyle = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const handleProductDetailsClose = () => {
    setProductDetailsOpen(false);
  };

  const handleBuyerRatingCloseModal = () => {
    setbuyerratingmodal(false);
  };

  const handleSellerRatingCloseModal = () => {
    setsellerratingmodal(false);
  };

  const refreshgetuserAddadmin = () => {
    setAddAdminModal(false);
    getCustomers();
  };

  const handleBuyerGetRatingModal = (row) => {
    setreviewratinglist('');
    handleGetUserReviewRating(row?.id, 'buyer');
    setuserdetail(row);
    setbuyerratingmodal(true);
  };

  const handleSellerGetRatingModal = (row) => {
    setreviewratinglist('');
    handleGetUserReviewRating(row?.id, 'seller');
    setuserdetail(row);
    setsellerratingmodal(true);
  };

  const handleGetPayment = (row) => {
    setuserdetail(row);
    setUserPaymentModal(true);
  };

  const handleGetUserReviewRating = (id, type) => {
    // setloading(true);
    setloadingReviews(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    // Construct the query string
    const queryParams = new URLSearchParams();
    // page && queryParams.append('page', page);
    queryParams.append('type', type);
    id && queryParams.append('user_id', id);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${api.get_user_rating}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setreviewratinglist(result.data);
          // result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
        } else {
          // setlist([]);
          // setpagesCount(0);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        // setloading(false);
        // setsearchLoading(false);
        setloadingReviews(false);
      });
  };

  const HistoryLogsTable = ({ user_id }) => {
    useEffect(() => {
      getUserHistory();
    }, []);

    const [historylogs, setHistoryLogs] = useState([]);
    const [loading, setloading] = useState(true);
    function getUserHistory() {
      setloading(true);
      const myHeaders = new Headers();

      const token = localStorage.getItem('token');
      myHeaders.append('Authorization', `Bearer ${token}`);

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      // Assuming the user_id needs to be part of the query string in the URL
      const url = `${api.get_login_logs}?user_id=${user_id}`;

      fetch(url, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            throw new Error('Failed to retrieve user history');
          }
        })
        .then((result_) => {
          const result = JSON.parse(result_);
          setHistoryLogs(result?.data);
        })
        .catch((error) => {})
        .finally(() => {
          setloading(false);
        });
    }
    return (
      <Box>
        <Typography variant="h5" textAlign={'center'}>
          Login History
        </Typography>

        <Card style={{ marginTop: 20 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="body2" fontWeight={'bold'}>
                    Devices Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={'bold'}>
                    Date & Time
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography variant="body2 " fontWeight={'bold'}>
                    IP Information
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historylogs.length > 0 &&
                historylogs?.map((item, index) => (
                  <>
                    <TableRow key={index}>
                      <TableCell>
                        <Typography variant="body2" color="black">
                          {item?.device_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {dayjs(item?.updated_at).format('DD, MMMM , YYYY h:mm A') || 'N/A'}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="caption">{item?.device_ip || 'N/A'}</Typography>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              {loading && (
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <CircularProgress color="inherit" size={16} />
                  </TableCell>
                </TableRow>
              )}
              {/* IDHR */}
              {historylogs.length == 0 && !loading && (
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={''} />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Card>

        <Box
          style={{
            justifyContent: 'flex-end',
            display: 'flex',
            marginTop: 30
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={handleProductDetailsClose}
            size={'small'}
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  };

  const styletablecell = {
    padding: '8px',
    whiteSpace: 'nowrap',
    width: 'auto'
  };

  const BuyerRating = ({ productDetails }) => {
    const [openRow, setOpenRow] = useState(null);
    const handleRowClick = (index) => {
      setOpenRow(openRow === index ? null : index);
    };
    return (
      <Box>
        <Typography variant="h5" textAlign={'center'}>
          Buyer Rating
        </Typography>
        <Stack direction="column" mb={1} spacing={2}>
          <Box
            py={0}
            width="40%"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box>
                <Avatar
                  alt={productDetails?.name}
                  src={productDetails?.avatar}
                  sx={{ width: 56, height: 56 }}
                />
              </Box>
              <Box>
                <div className="one-line-ellipsis" style={{ fontSize: 20 }}>
                  {productDetails?.name || 'N/A'}
                </div>
                <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                  {productDetails?.email || 'N/A'}
                </div>
                <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                  {productDetails?.contact_no || 'N/A'}
                </div>
              </Box>
            </Stack>
          </Box>

          <Divider variant="fullWidth" style={{ marginTop: 10, width: 350 }} />

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              flex: 1,
              marginTop: 10
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h5" component="div">
              Over All Order Rating:
            </Typography>
            <Box display={'flex'} alignItems={'center'}>
              <Rating
                precision={0.1}
                readOnly
                size="large"
                name="simple-controlled"
                value={productDetails?.count?.over_all_buyer_rating}
              />
              <Typography ml={1} variant="h5">
                {productDetails?.count?.over_all_buyer_rating}/5
              </Typography>
            </Box>
          </Box>
          <Divider style={{ width: 350 }} />

          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ width: 105, marginRight: 5 }} component="div">
              Buyer Rating:
            </Typography>

            <Box display={'flex'} alignItems={'center'}>
              <Rating
                precision={0.1}
                readOnly
                name="simple-controlled"
                value={productDetails?.count?.buyer_rating}
              />
              <Typography ml={1} variant="subtitle2">
                {productDetails?.count?.buyer_rating}/5
              </Typography>
            </Box>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ width: 105, marginRight: 5 }} component="div">
              Vintit Rating:{' '}
            </Typography>

            <Box display={'flex'} alignItems={'center'}>
              <Rating
                precision={0.1}
                readOnly
                name="simple-controlled"
                value={productDetails?.count?.over_all_vint_buyer_rating}
              />
              <Typography ml={1} variant="subtitle2">
                {productDetails?.count?.over_all_vint_buyer_rating}/5
              </Typography>
            </Box>
          </Box>
        </Stack>

        <Scrollbar flex>
          <TableContainer sx={{ minWidth: 800 }} p style={styletablecell}>
            <Card style={{ marginTop: 20 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Order No
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Buyer Rating
                      </Typography>
                    </TableCell>
                    <TableCell style={styletablecell}>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Vintit Rating
                      </Typography>
                    </TableCell>
                    <TableCell style={styletablecell}>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Over all Order Rating
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reviewratinglist &&
                    reviewratinglist.map((item, index) => (
                      <React.Fragment key={index}>
                        <TableRow onClick={() => handleRowClick(index)}>
                          <TableCell
                            style={{
                              flexDirection: 'row',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <IconButton aria-label="expand row" size="small">
                              {openRow === index ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                            <Typography variant="body2" color="black">
                              {item?.order?.order_no || 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {item.rating ? item?.rating + '/5' : 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {item.vint_rating ? item.vint_rating + '/5' : 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {item.over_all_rating ? item?.over_all_rating + '/5' : 'N/A'}
                            </Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                            <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                              <Box margin={1}>
                                <Typography variant="h6">Seller's Feedback:</Typography>
                                <Typography
                                  style={{
                                    maxWidth: '100%',
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal'
                                  }}
                                  flexWrap={'wrap'}
                                >
                                  {item?.review || 'N/A'}
                                </Typography>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                </TableBody>
                {reviewratinglist.length === 0 && !loadingReviews && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                {loadingReviews && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <CircularProgress size={16} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </Card>
          </TableContainer>
        </Scrollbar>

        <Box
          style={{
            justifyContent: 'flex-end',
            display: 'flex',
            marginTop: 30
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleBuyerRatingCloseModal();
            }} // Add your handler here
            size={'small'}
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  };

  const SellerRating = ({ productDetails }) => {
    const [openRow, setOpenRow] = useState(null);
    const handleRowClick = (index) => {
      setOpenRow(openRow === index ? null : index);
    };
    return (
      <Box>
        <Typography variant="h5" textAlign={'center'}>
          Seller Rating
        </Typography>
        <Stack direction="column" mb={1} spacing={2}>
          <Box
            py={0}
            width="40%"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box>
                <Avatar
                  alt={productDetails?.name}
                  src={productDetails?.avatar}
                  sx={{ width: 56, height: 56 }}
                />
              </Box>
              <Box>
                <div className="one-line-ellipsis" style={{ fontSize: 20 }}>
                  {productDetails?.name || 'N/A'}
                </div>
                <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                  {productDetails?.email || 'N/A'}
                </div>
                <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                  {productDetails?.contact_no || 'N/A'}
                </div>
              </Box>
            </Stack>
          </Box>

          <Divider variant="fullWidth" style={{ marginTop: 10, width: 350 }} />

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              flex: 1,
              marginTop: 10
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h5" component="div">
              Over All Order Rating:
            </Typography>
            <Box display={'flex'} alignItems={'center'}>
              <Rating
                precision={0.1}
                readOnly
                size="large"
                name="simple-controlled"
                value={productDetails?.count?.over_all_seller_rating}
              />
              <Typography ml={1} variant="h5">
                {productDetails?.count?.over_all_seller_rating}/5
              </Typography>
            </Box>
          </Box>
          <Divider style={{ width: 350 }} />

          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ width: 105, marginRight: 5 }} component="div">
              Seller Rating:
            </Typography>

            <Box display={'flex'} alignItems={'center'}>
              <Rating
                precision={0.1}
                readOnly
                name="simple-controlled"
                value={productDetails?.count?.seller_rating}
              />
              <Typography ml={1} variant="subtitle2">
                {productDetails?.count?.seller_rating}/5
              </Typography>
            </Box>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ width: 105, marginRight: 5 }} component="div">
              Vintit Rating:{' '}
            </Typography>

            <Box display={'flex'} alignItems={'center'}>
              <Rating
                precision={0.1}
                readOnly
                name="simple-controlled"
                value={productDetails?.count?.over_all_vint_seller_rating}
              />
              <Typography ml={1} variant="subtitle2">
                {productDetails?.count?.over_all_vint_seller_rating}/5
              </Typography>
            </Box>
          </Box>
        </Stack>

        <Scrollbar flex>
          <TableContainer sx={{ minWidth: 800 }} p style={styletablecell}>
            <Card style={{ marginTop: 20 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Order No
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Seller Rating
                      </Typography>
                    </TableCell>
                    <TableCell style={styletablecell}>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Vintit Rating
                      </Typography>
                    </TableCell>
                    <TableCell style={styletablecell}>
                      <Typography variant="body2" fontWeight={'bold'}>
                        Over all Order Rating
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reviewratinglist &&
                    reviewratinglist.map((item, index) => (
                      <React.Fragment key={index}>
                        <TableRow onClick={() => handleRowClick(index)}>
                          <TableCell
                            style={{
                              flexDirection: 'row',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <IconButton aria-label="expand row" size="small">
                              {openRow === index ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                            <Typography variant="body2" color="black">
                              {item?.order?.order_no || 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {item.rating ? item?.rating + '/5' : 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {item.vint_rating ? item.vint_rating + '/5' : 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {item.over_all_rating ? item?.over_all_rating + '/5' : 'N/A'}
                            </Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                            <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                              <Box margin={1}>
                                <Typography variant="h6">Buyer's Feedback:</Typography>
                                <Typography
                                  style={{
                                    maxWidth: '100%',
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal'
                                  }}
                                  flexWrap={'wrap'}
                                >
                                  {item?.review || 'N/A'}
                                </Typography>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                </TableBody>
                {reviewratinglist.length === 0 && !loadingReviews && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                {loadingReviews && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <CircularProgress size={16} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </Card>
          </TableContainer>
        </Scrollbar>

        <Box
          style={{
            justifyContent: 'flex-end',
            display: 'flex',
            marginTop: 30
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleSellerRatingCloseModal();
            }} // Add your handler here
            size={'small'}
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'success';
      case 'deleted':
        return 'error';
      case 'blocked':
        return 'warning';
      case 'suspended':
        return 'warning';
      case 'pending':
        return 'info';
      default:
        return 'primary';
    }
  };
  function OpenCompanyModal(row) {
    setcompanyprofiledata(row);
    setcompanymodal(true);
  }

  const handleCloseCompanyModal = () => {
    setcompanymodal(false);
  };

  const currentStatus = user?.status;
  const updatedStatusOptions = statusList.filter((option) => {
    if (currentStatus === 'active') {
      return ['Block', 'Delete'].includes(option?.name);
    }
    if (currentStatus === 'blocked') {
      return ['Active', 'Delete'].includes(option?.name);
    }
    if (currentStatus === 'deleted') {
      return ['Active'].includes(option?.name);
    }
    if (currentStatus === 'pending') {
      return ['Active', 'Delete'].includes(option?.name);
    }
    return true; // If none of the conditions match, return all options
  });

  const getProfileName = (object) => {
    if (!object.company && object.employee) return 'Employee';
    if (!object.employee && object.company) return 'Company';
    if (object.employee || object.company) return 'Employee / Company';
    if (!object.employee && !object.company) return 'N/A';
  };

  return (
    <Page title={`Customers | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* LOGIN HISTORY */}
        <Modal open={productDetailsOpen} onClose={handleProductDetailsClose} style={historystyle}>
          <Box sx={HistoryboxStyle} px={5} pt={2} pb={5}>
            <HistoryLogsTable user_id={userdetail?.id} />
          </Box>
        </Modal>
        {/* buyer rating modal */}
        <Modal open={buyerratingmodal} onClose={handleBuyerRatingCloseModal} style={historystyle}>
          <Box sx={HistoryboxStyle} px={5} pt={2} pb={5}>
            <BuyerRating productDetails={userdetail} />
          </Box>
        </Modal>
        {/* SELLER RATING */}
        <Modal open={sellerratingmodal} onClose={handleSellerRatingCloseModal} style={historystyle}>
          <Box sx={HistoryboxStyle} px={5} pt={2} pb={5}>
            <SellerRating productDetails={userdetail} />
          </Box>
        </Modal>
        {/* RESET USER MODAL */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openReset}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <ResetUserPassword user={user} handleClose={handleCloseModal} />
          </Box>
        </Modal>
        {/* CHANGE ROLE  */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <ChangeRoleModal user={user} handleClose={handleClose} refreshAdmin={refreshAdmin} />
          </Box>
        </Modal>
        {/* EDIT USER */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openUser}
          onClose={handleCloseUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <EditUserModal
              user={user}
              handleClose={handleCloseUserModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>
        {/* ADD ADMIN MODAL */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={AddAdminmodal}
          onClose={handleAddAdminCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <AddAdminModal
              fullWidth={true}
              user={roles}
              handleClose={handleAddAdminCloseModal}
              refreshAdmin={refreshgetuserAddadmin}
            />
          </Box>
        </Modal>
        {/* USER DETAIL PAYMENT METHOD */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={userpaymentmodal}
          onClose={() => setUserPaymentModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <UserDetailPaymentAdmin
              userDetail={userdetail}
              onClose={() => setUserPaymentModal(false)}
            />
          </Box>
        </Modal>
        {/* CHANGE STATUS */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openStatus}
          onClose={handleCloseStatus}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, style }} className="admin_modal_pa">
            <Box p={1} py={3} flexDirection={'column'} display={'flex'} flex={1}>
              <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Change Status
              </Typography>
              <CardContent>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: 20,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <span>Current Status:</span>
                  <Label
                    style={{ height: 30, width: 100 }}
                    variant="ghost"
                    color={getStatusColor(selectedStatus?.value)}
                  >
                    <div
                      style={{
                        // marginLeft: 8,
                        padding: '4px 10px',
                        borderRadius: 4,
                        fontWeight: 'bold',
                        textTransform: 'capitalize'
                      }}
                    >
                      {selectedStatus?.value || 'N/A'}
                    </div>
                  </Label>
                </Typography>

                <TextField
                  defaultValue={selectedStatus}
                  style={{ width: '100%' }}
                  select
                  value={statusss}
                  label="Status"
                  onChange={handleChange}
                  className="width_full_status"
                >
                  {updatedStatusOptions.map((option) => (
                    <MenuItem key={option.id} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                <Box mt={2} />
                {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
                  <LoadingButton
                    disabled={!statusss}
                    style={{ marginTop: 20, marginRight: 10 }}
                    onClick={() => {
                      handleChangeStatus(statusss);
                    }}
                    variant="contained"
                    loading={statusLoading}
                  >
                    Save
                  </LoadingButton>
                  <Button
                    style={{ marginTop: 20 }}
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                      handleCloseStatus();
                    }}
                    size="large"
                  >
                    Close
                  </Button>
                </Box>
              </CardContent>
            </Box>
          </Box>
        </Modal>
        {/* company profile modal */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={companymodal}
          onClose={handleCloseCompanyModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '70%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1,
              style
            }}
          >
            <CompanyProfile
              user={companyprofiledata}
              handleClose={handleCloseCompanyModal}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Customers
          </Typography>
        </Stack>

        {alertSuccess && alertSuccess.visible && (
          <Alert style={{ marginBottom: 20 }} severity="success">
            {alertSuccess.message}
          </Alert>
        )}
        <Card
          sx={{
            bgcolor: '#151921',
            color: '#fff',
            borderRadius: 2,
            boxShadow: '0px 4px 20px rgba(0,0,0,0.4)'
          }}
        >
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={t('Agents.search')}
              onEnter={() => {
                setsearchLoading(true);
                list.length = 0;
                getCustomers(1, statusfilter, reasondrop);
              }}
            />

            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getCustomers(1, statusfilter, reasondrop);
              }}
              className="width_full_status"
            >
              {' '}
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>

            <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={statusfilter}
              label={'Status'}
              onChange={handlefilterstatus}
              className="width_full_status"
              InputLabelProps={{ shrink: true }} // Correct prop for label shrink
            >
              {statusList.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={list.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                {/* {console.log(list.length, 'LIST LENGTH CHECK')} */}
                <TableBody>
                  {list?.map((row) => {
                    // console.log('🚀 ~ {list?.map ~ row:', row);
                    const { id, username, company, avatar, email, seen, status, employee, joined } =
                      row;
                    // console.log('company', company, '============', employee);

                    return (
                      <TableRow
                        hover
                        style={{
                          backgroundColor: seen == '0' && 'rgba(253,208,151,0.2)',
                          cursor: seen == '0' ? 'pointer' : 'default'
                        }}
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                      >
                        {/* <TableCell scope="row" padding="normal" style={{ width: 200 }}>
                          <Stack direction="row" alignItems="center">
                            <Box
                              style={{
                                display: 'flex',
                                width: 60,
                                marginRight: 5,
                                backgroundColor: 'red',
                                justifyContent: company && employee ? 'flex-start' : 'center'
                              }}
                            >
                              {company && (
                                <Avatar
                                  alt={username}
                                  src={company?.avatar}
                                  style={{
                                    zIndex: 1,
                                    width: 35,
                                    height: 35,
                                    border: '2px solid white'
                                  }}
                                />
                              )}
                              {employee && (
                                <Avatar
                                  alt={username}
                                  src={employee?.avatar}
                                  style={{
                                    // position: 'absolute',
                                    left: -15,
                                    zIndex: 1,
                                    width: 35,
                                    height: 35,
                                    border: '2px solid white'
                                  }}
                                />
                              )}
                            </Box>
                            <Box
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                maxWidth: 100
                              }}
                            >
                              <Typography
                                fontSize={12}
                                variant="subtitle2"
                                style={{
                                  display: 'block',
                                  maxWidth: '120px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {username === 'undefined' ? 'N/A' : username}
                              </Typography>
                              <Typography
                                fontSize={12}
                                variant="subtitle2"
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block',
                                  maxWidth: '180px'
                                }}
                              >
                                {email || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell> */}
                        <TableCell scope="row" padding="normal" style={{ width: 200 }}>
                          <Stack direction="row" alignItems="center">
                            {/* Avatar Container */}
                            {/* <Box
                              style={{
                                display: 'flex',
                                width: 60,
                                marginRight: 5,
                                alignItems: 'center',
                                justifyContent: company && employee ? 'flex-start' : 'center'
                                // flexShrink: 0 // Prevents shrinking when text increases
                              }}
                            >
                              {employee && (
                                <Avatar
                                  alt={username}
                                  src={employee?.avatar}
                                  style={{
                                    left: company && employee && 15,
                                    zIndex: 1,
                                    width: 35,
                                    height: 35,
                                    border: '2px solid white',
                                    position: company ? 'absolute' : 'relative'
                                  }}
                                />
                              )}

                              {company && (
                                <Avatar
                                  alt={username}
                                  src={company?.avatar}
                                  style={{
                                    marginLeft: company && employee && 20,
                                    zIndex: 0,
                                    width: 35,
                                    height: 35,
                                    border: '2px solid white',
                                    position: company && employee ? 'absolute' : 'relative'
                                  }}
                                />
                              )}
                            </Box> */}

                            {/* Text Container */}
                            <Box
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 1, // Allows text to take available space
                                minWidth: 100 // Ensures a minimum width for text
                                // backgroundColor: 'red'
                              }}
                            >
                              <Typography
                                fontSize={12}
                                variant="subtitle2"
                                style={{
                                  display: 'block',
                                  whiteSpace: 'nowrap', // Keeps text in one line
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {username === 'undefined' ? 'N/A' : username}
                              </Typography>
                              <Typography
                                fontSize={12}
                                variant="subtitle2"
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block'
                                }}
                              >
                                {email || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>
                        <TableCell align="left" style={{ maxWidth: 120 }}>
                          <Typography fontSize={12}>
                            {company?.name ? company?.name : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* <TableCell align="left" style={{ maxWidth: 150 }}>
                          <Typography
                            fontSize={12}
                            // variant="subtitle2"
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: 'block',
                              maxWidth: '100px'
                            }}
                          >
                            {email || 'N/A'}
                          </Typography>
                        </TableCell> */}
                        <TableCell align="left" style={{ maxWidth: 100 }}>
                          <Typography fontSize={12}> {joined || 'N/A'}</Typography>
                        </TableCell>{' '}
                        <TableCell align="left" style={{ maxWidth: 70 }}>
                          <Typography fontSize={12}>{getProfileName(row)}</Typography>
                        </TableCell>
                        {/* <TableCell align="left" style={{ maxWidth: 70 }}>
                          <Typography
                            style={{
                              textDecoration: 'underline',
                              cursor: 'pointer'
                            }}
                            onClick={() => {
                              handleBuyerGetRatingModal(row);
                            }}
                          >
                            {count?.over_all_buyer_rating
                              ? count?.over_all_buyer_rating + '/5'
                              : 'N/A'}
                          </Typography>
                        </TableCell>*/}
                        <TableCell align="left" style={{ maxWidth: 110 }}>
                          <Label
                            style={{ height: 30, width: 100 }}
                            variant="ghost"
                            color={getStatusColor(status)}
                          >
                            <Typography
                              style={{
                                textTransform: 'capitalize',
                                fontWeight: 'bold',
                                fontSize: 12
                              }}
                            >
                              {status}
                            </Typography>
                          </Label>
                        </TableCell>
                        <TableCell align="left">
                          <Box display="flex" flexDirection="row" m={0}>
                            {permission.includes('change password') && (
                              <Tooltip title="Change Password">
                                <LoadingButton
                                  disabled={status.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={() => openResetModal(row)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="solar:password-bold"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('change status') && (
                              <Tooltip title="Change Status">
                                <LoadingButton
                                  disabled={
                                    status.toLowerCase() == 'deleted' ||
                                    status?.toLowerCase() == 'pending'
                                  }
                                  size="small"
                                  onClick={() => {
                                    openModalStatus(row);
                                    setstatus(status);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="tabler:status-change"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {/* {permission.includes('login history') && (
                              <Tooltip title="Login History">
                                <LoadingButton
                                  disabled={status.toLowerCase() == 'deleted'}
                                  size="small"
                                  onClick={() => {
                                    setuserdetail(row);
                                    setProductDetailsOpen(true);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="material-symbols:history"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )} */}

                            {permission.includes('visible') && (
                              <Tooltip title="Employee Profile">
                                <LoadingButton
                                  disabled={
                                    status?.toLowerCase() == 'deleted' ||
                                    status?.toLowerCase() == 'pending' ||
                                    !employee
                                  }
                                  size="small"
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  component={RouterLink}
                                  to="/dashboard/customers/customerscompanyprofile"
                                  state={{ userid: employee?.id }}
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="solar:user-id-bold"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('visible') && (
                              <Tooltip title="Company Profile">
                                <LoadingButton
                                  disabled={
                                    status?.toLowerCase() == 'deleted' ||
                                    status?.toLowerCase() == 'pending' ||
                                    !company
                                  }
                                  size="small"
                                  onClick={() => OpenCompanyModal(company?.id)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 0.5
                                  }}
                                  // component={RouterLink}
                                  // to="/dashboard/users/usercompanyprofile"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="solar:user-id-bold"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {/* EMPTY STATE */}
                {list.length === 0 && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {/* LOADER */}
              {loading && !searchLoading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </TableContainer>
          </Scrollbar>
        </Card>
        {/* PAGINATION */}
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
